import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import { FAULT_KIND_OPTIONS } from 'components/tables/data/fault/kind';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'kind' as const;

/**
 * Parameters of the FaultKindSelectFilter component.
 */
export interface FaultKindSelectFilterProps {
  api: GridApi;
  onChange?: FilterChangeCallback;
}

/**
 * Filter component for the fault kind column.
 *
 * This filter assumes:
 * - column field is `kind`
 */
export default function FaultKindSelectFilter({ api, onChange }: FaultKindSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <Select
      searchable
      clearable
      w="100%"
      size="sm"
      placeholder="Akýkoľvek pôvod"
      data={FAULT_KIND_OPTIONS}
      value={value}
      onChange={setValue}
    />
  );
}
